'use client';

import { useTranslation } from 'react-i18next';

/**
 * Tiny pill rendered next to a section header when the row was
 * served from the snapshot cache rather than a fresh backend
 * response. Communicates "this might be slightly out of date" so the
 * user understands ordering quirks rather than blaming the UI.
 * Token-driven for dark/light parity.
 */
export function StaleIndicator() {
  const { t } = useTranslation('site-builder-blocks');
  return (
    <span
      role="status"
      aria-label={t('shared.stale.label')}
      title={t('shared.stale.title')}
      style={{
        fontSize: '11px',
        fontWeight: 500,
        letterSpacing: 0,
        textTransform: 'none',
        padding: 'var(--space-0-5, 2px) var(--space-2, 8px)',
        borderRadius: 999,
        background: 'var(--color-surface-page, rgba(127, 127, 127, 0.08))',
        color: 'var(--color-text-tertiary, #94867d)',
        border: '1px solid var(--color-border-subtle, rgba(0, 0, 0, 0.08))',
        whiteSpace: 'nowrap',
      }}
    >
      {t('shared.stale.badge')}
    </span>
  );
}
